<ul *ngIf="totalPages && totalPages > 1" class="pagination">
  <li [ngClass]="{disabled:actualPage === 1}" class="page-item first-item m-auto click">
      <a (click)="setPage(1)" class="page-link"><mat-icon>skip_previous</mat-icon></a>
  </li>
  <li [ngClass]="{disabled:actualPage === 1}" class="page-item previous-item m-auto click">
      <a (click)="setPage(actualPage - 1)" class="page-link"><mat-icon>navigate_before</mat-icon></a>
  </li>
  <li *ngFor="let page of pages; trackBy: trackByIndex" [ngClass]="{active:actualPage === page}" class="page-item number-item m-auto click">
      <a (click)="setPage(page)" class="page-link">{{page}}</a>
  </li> 
  <li [ngClass]="{disabled:actualPage === totalPages}" class="page-item next-item m-auto click">
      <a (click)="setPage(actualPage + 1)" class="page-link"><mat-icon>navigate_next</mat-icon></a>
  </li>
  <li [ngClass]="{disabled:actualPage === totalPages}" class="page-item last-item m-auto click">
      <a (click)="setPage(totalPages)" class="page-link"><mat-icon>skip_next</mat-icon></a>
  </li> 
</ul> 